/**
 * @fileoverview Action types for Click&Pledge donation feature.
 * Contains all action type constants used in the Click&Pledge Redux flow.
 */

/** Action type for binding meet data */
export const MEET_DATA = 'MEET_DATA';

/** Action type for user account information */
export const USERACCOUNTINFO = 'USERACCOUNTINFO';

/** Action type for form GUID */
export const FORMGUID = 'FORMGUID';

/** Action type for form settings */
export const FORMSETTINGS = 'FORMSETTINGS';

/** Action type for Givent ID */
export const GIVENTID = 'GIVENTID';

/** Action type for account mode */
export const ACCOUNTMODE = 'ACCOUNTMODE';

/** Action type for charge date data */
export const CHARGEDATEDATA = 'CHARGEDATEDATA';

/** Action type for event expiration status */
export const ISEVENTEXPIRED = 'ISEVENTEXPIRED';

/** Action type for meet form data */
export const MEETFORMDATA = 'MEETFORMDATA';

/** Action type for donation form details */
export const DONATIONFORMDETAILS = 'DONATIONFORMDETAILS';

/** Action type for recurring section */
export const RECURRINGSECTION = 'RECURRINGSECTION';

/** Action type for amount section */
export const AMOUNTSECTION = 'AMOUNTSECTION';

/** Action type for recurring selection */
export const RECURRINGSELECTION = 'RECURRINGSELECTION';

/** Action type for recurring method */
export const RECURRINGMETHOD = 'RECURRINGMETHOD';

/** Action type for payment type method */
export const PAYMENTTYPEMETHOD = 'PAYMENTTYPEMETHOD';

/** Action type for selected donation amount */
export const DONATIONAMOUNTSELECTED = 'DONATIONAMOUNTSELECTED';

/** Action type for donation amount index */
export const DONATIONAMOUNTINDEX = 'DONATIONAMOUNTINDEX';

/** Action type for donation items */
export const DONATIONITEMS = 'DONATIONITEMS';

/** Action type for number of periodicity */
export const NOOFPERIODICITY = 'NOOFPERIODICITY';

/** Action type for periodicity end date */
export const PERIODICITYENDDATE = 'PERIODICITYENDDATE';

/** Action type for showing one time payment option */
export const SHOWONETIMEPAYOPTION = 'SHOWONETIMEPAYOPTION';

/** Action type for no recurring option available */
export const NORECURRINGOPTIONAVAILABLE = 'NORECURRINGOPTIONAVAILABLE';

/** Action type for payment section */
export const PAYMENTSECTION = 'PAYMENTSECTION';

/** Action type for payment order number */
export const PAYMENTORDERNO = 'PAYMENTORDERNO';

/** Action type for payment error */
export const PAYMENTERR = 'PAYMENTERR';

/** Action type for storing form instance data (replaces /createforminstance) */
export const FORM_INSTANCE_DATA = 'FORM_INSTANCE_DATA';

/** Action type for storing form GUID data (replaces /saveformguid) */
export const SAVE_FORM_GUID_DATA = 'SAVE_FORM_GUID_DATA';

/** Action type for storing user form data (replaces /getuserform) */
export const USER_FORM_DATA = 'USER_FORM_DATA';

/** Action type for form publish status (replaces /publishform) */
export const FORM_PUBLISH_STATUS = 'FORM_PUBLISH_STATUS';

/** Action type for donation info data (replaces /saveinfo) */
export const DONATION_INFO_DATA = 'DONATION_INFO_DATA';

/** Action type for stream info data (replaces /getstreaminfo) */
export const STREAM_INFO_DATA = 'STREAM_INFO_DATA';

/** Action type for touched fields */
export const TOUCHEDFIELDS = 'TOUCHEDFIELDS';

/** Action type for installment selection */
export const INSTALLEMENTSELECTED = 'INSTALLEMENTSELECTED';

/** Action type for installment error status */
export const HASINSTALLMENTERROR = 'HASINSTALLMENTERROR';

/** Action type for less installment amount status */
export const HASLESSINSTALLMENTAMT = 'HASLESSINSTALLMENTAMT';

/** Action type for installment error message */
export const INSTALLMENTERRORMSG = 'INSTALLMENTERRORMSG';

/** Action type for installment charge */
export const INSTALLMENTCHARGE = 'INSTALLMENTCHARGE';

/** Action type for installment touched status */
export const ISINSTALLMENTTOUCHED = 'ISINSTALLMENTTOUCHED';

/** Action type for indefinite recurring status */
export const ISINDEFINITERECURRING = 'ISINDEFINITERECURRING';

/** Action type for convenience fee section */
export const CONVENIENCEFEESECTION = 'CONVENIENCEFEESECTION';

/** Action type for convenience fee amount */
export const CONVENIENCEFEEAMOUNT = 'CONVENIENCEFEEAMOUNT';

/** Action type for convenience fee selection */
export const CONVENIENCEFEESELECTED = 'CONVENIENCEFEESELECTED';

/** Action type for final donation amount */
export const FINALDONATIONAMT = 'FINALDONATIONAMT';

/** Action type for final donation amount error */
export const FINALDONATIONAMOUNTERROR = 'FINALDONATIONAMOUNTERROR';

/** Action type for donation amount empty status */
export const ISDONATIONAMOUNTEMPTY = 'ISDONATIONAMOUNTEMPTY';

/** Action type for donation completion status */
export const ISDONATIONDONE = 'ISDONATIONDONE';

/** Action type for default donation amount */
export const DEFAULTDONATIONAMOUNT = 'DEFAULTDONATIONAMOUNT';

/** Action type for other amount min/max error */
export const OTHERAMOUNTMINMAXERROR = 'OTHERAMOUNTMINMAXERROR';

/** Action type for validation section */
export const VALIDATIONSECTION = 'VALIDATIONSECTION';

/** Action type for show/hide form */
export const SHOWHIDEFORM = 'SHOWHIDEFORM';

/** Action type for payment section touched status */
export const ISPAYSECTOUCHED = 'ISPAYSECTOUCHED';

/** Action type for show as anonymous */
export const SHOWASANONYMOUS = 'SHOWASANONYMOUS';

/** Action type for donation order items */
export const DONATIONORDERITEMS = 'DONATIONORDERITEMS';

/** Action type for convenience fee order item */
export const CONFEEORDERITEM = 'CONFEEORDERITEM';

/** Action type for payment order item */
export const PAYMENTORDERITEM = 'PAYMENTORDERITEM';

/** Action type for multi donation order items */
export const MULTIDONATIONORDERITEMS = 'MULTIDONATIONORDERITEMS';

/** Action type for multi payment total tax deduction */
export const MULTIPAYTOTALTAXDEDUCT = 'MULTIPAYTOTALTAXDEDUCT';

/** Action type for multi donation error */
export const MULTIDONATIONERR = 'MULTIDONATIONERR';

/** Action type for multi donation values */
export const MULTIDONATIONVALS = 'MULTIDONATIONVALS';

/** Action type for campaign raised details */
export const CAMPAIGNRAISEDDETAILS = 'CAMPAIGNRAISEDDETAILS';

/** Action type for stream options */
export const STREAMOPTIONS = 'STREAMOPTIONS';

/** Action type for donation stream */
export const DONATIONSTREAM = 'DONATIONSTREAM';

/** Action type for total donation amount */
export const TOTALDONATIONAMOUNT = 'TOTALDONATIONAMOUNT';

/** Action type for last stream time */
export const LASTSTREAMTIME = 'LASTSTREAMTIME';

/** Action type for Click&Pledge enabled status */
export const IS_ENABLED = 'IS_ENABLED';

/** Action type for Givent token */
export const GIVENT_TOKEN = 'INIT_DATA_CLICKANDPLEDGE';

/** Action type for user ID */
export const USERID = 'USERID';

/** Action type for resetting Click&Pledge state */
export const RESET_CLICKANDPLEDGE = 'RESET_CLICKANDPLEDGE';

/** Action type for donation marquee data */
export const DONATION_MAREQUE = 'DONATION_MAREQUE';

/** Action type for caching Click&Pledge API responses */
export const SET_CNP_API_CACHE = 'SET_CNP_API_CACHE';

/** Action type for clearing form-related API cache (preserves registration cache) */
export const CLEAR_FORM_API_CACHE = 'CLEAR_FORM_API_CACHE';


export const CNP_PAYQUICKLY_DATA = 'CNP_PAYQUICKLY_DATA';

export const RENDER_POPUP_OVERLAY = 'RENDER_POPUP_OVERLAY';

/** Action type for marquee closed/open state */
export const IS_MARQUEE_CLOSED = 'IS_MARQUEE_CLOSED';

/** Action type for broadcasting form published notification to all participants */
export const FORM_PUBLISHED_NOTIFICATION = 'FORM_PUBLISHED_NOTIFICATION';

/** Action type for a wallet-payment deep-link return (go.meethour.io:// re-entry) */
export const WALLET_CONTACT_OVERRIDE = 'WALLET_CONTACT_OVERRIDE';

export const WALLET_PAYMENT_RETURN = 'WALLET_PAYMENT_RETURN';
